/* unplugin-vue-components disabled */import script from "./search.vue?vue&type=script&setup=true&lang=js"
export * from "./search.vue?vue&type=script&setup=true&lang=js"

import "./search.vue?vue&type=style&index=0&id=06e7b5f2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e7b5f2"]])

export default __exports__